@for (heatSource of thermostatFeatureSourcePriorities; track heatSource) {
  <div class="border-style-equipment mt-4">
    <div>
      <div class="equipment-name">
        <img class="equipment-icon" [src]="getHeatSourceIcon(heatSource.category)"/>
        <span>{{ heatSource.displayName }}</span>
        <span class="mr-2" style="margin-left: auto;">
          <img class="availability-icon" [src]="getAvailabilityIcon(heatSource.availabilityStatus)"/>
          {{ heatSource.availabilityStatus | splitCamelCaseTitle }}
        </span>
      </div>

      <hr class="mt-0 mb-0 ml-2 mr-2">

      <!-- Source Priority -->
      <div class="grid-container p-2">

        <!-- Current Status -->
        <div class="grid-item m-2">
          <span class="equipment-grid">{{ 'lang.current_status' | translate }}</span><br>
          <span class="equipment-grid-value">{{ heatSource?.currentStatus }}</span>
        </div>

        <!-- Heating Speed -->
        <div class="grid-item m-2">
          <span class="equipment-grid">{{ 'lang.heating_speed' | translate }}</span><br>
          <span class="equipment-grid-value">
            <img [src]="getHeatingSpeedIcon(heatSource?.heatingSpeed)"/>
          </span>
        </div>

        <!-- Energy Efficiency -->
        <div class="grid-item m-2">
          <span class="equipment-grid">{{ 'lang.energy_efficiency' | translate }}</span><br>
          <span class="equipment-grid-value">
            <img [src]="getEnergyEfficiencyIcon(heatSource?.energyEfficiency)"/>
          </span>
        </div>
      </div>
    </div>
  </div>
}